import { ICollectionStatistics } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { CURRENCY_SYMBOL } from 'src/constants/common.constants';
import { useFiatCurrency } from 'src/features/common/profile/hooks/profile.hooks';
import { Grid } from 'src/ui/common/atoms/grid';
import { formatNumberToNumGroup, makePriceFromCents } from 'src/utils/entity.utils';
import { StyledItem, StyledItemValue, StyledItemLabel } from './collection-statistics.styles';

interface IProps {
    className?: string;
    data?: ICollectionStatistics;
}

export const CollectionStatistics: React.VFC<IProps> = ({ className, data }) => {
    const { t } = useTranslation('components');
    const fiatCurrency = useFiatCurrency();
    const currency = CURRENCY_SYMBOL[fiatCurrency];

    const floorPrice = data?.floorPrice
        ? `${currency}${formatNumberToNumGroup(makePriceFromCents(+data.floorPrice), 2)}`
        : '0';
    const totalVolume = data?.totalVolume
        ? `${currency}${formatNumberToNumGroup(makePriceFromCents(+data.totalVolume), 2)}`
        : '0';
    const avgSalePrice = data?.avgSalePrice
        ? `${currency}${formatNumberToNumGroup(makePriceFromCents(+data.avgSalePrice), 2)}`
        : '0';
    const totalSupply = data?.totalSupply
        ? `${currency}${formatNumberToNumGroup(makePriceFromCents(+data.totalSupply), 2)}`
        : '0';

    return (
        <Grid className={className} xs={3} columnGap={3} rowGap={3}>
            <StyledItem>
                <StyledItemValue medium>{floorPrice}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.floorPrice')}
                </StyledItemLabel>
            </StyledItem>
            <StyledItem>
                <StyledItemValue medium>{totalVolume}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.totalVolume')}
                </StyledItemLabel>
            </StyledItem>
            <StyledItem>
                <StyledItemValue medium>{avgSalePrice}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.avgSalePrice')}
                </StyledItemLabel>
            </StyledItem>
            <StyledItem>
                <StyledItemValue medium>{data?.itemsListed ?? 0}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.itemsListed')}
                </StyledItemLabel>
            </StyledItem>
            <StyledItem>
                <StyledItemValue medium>{totalSupply}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.totalSupply')}
                </StyledItemLabel>
            </StyledItem>
            <StyledItem>
                <StyledItemValue medium>{data?.uniqueHolders ?? 0}</StyledItemValue>
                <StyledItemLabel size="xxs" sizeMd="base">
                    {t('statistics.uniqueHolders')}
                </StyledItemLabel>
            </StyledItem>
        </Grid>
    );
};
